import { OCCUPANCY_USE } from '../components/Pages/Reports/constants';
import { OccupancyUse } from '../types/reports';
import { formatAmount } from './formatAmount';

export const calculateMortgageInterest = (
  interestRate: number,
  loanAmount: number,
  loanPeriodInYears: number,
  occupancyUse: OccupancyUse,
) => {
  const defaultYears = 30;
  const numPaymentsPerYear = 12;
  let adjustedLoanAmount = loanAmount;
  let loanPeriod;

  if (loanPeriodInYears) {
    loanPeriod = loanPeriodInYears * numPaymentsPerYear;
  } else {
    loanPeriod = defaultYears * numPaymentsPerYear;
  }

  if (occupancyUse === OCCUPANCY_USE.PRIMARY_RESIDENCE) {
    adjustedLoanAmount = adjustedLoanAmount > 750000 ? 750000 : adjustedLoanAmount;
  }

  const monthlyRate = interestRate / 12 / 100;

  const numerator = monthlyRate * adjustedLoanAmount;
  const denominator = 1 - (1 + monthlyRate) ** -loanPeriod;
  const payment = (numerator / denominator) || 0;

  const balanceArray: number[] = [];
  const interestArray: number[] = [];
  const principalArray: number[] = [];

  for (let day = 0; day < loanPeriod; day++) {
    let firstBalance;
    let firstInterest;
    let firstPrincipal;

    if (day === 0) {
      firstBalance = adjustedLoanAmount;
      firstInterest = parseFloat(((firstBalance * (interestRate / 100)) / numPaymentsPerYear).toFixed(2));
      firstPrincipal = payment - firstInterest;
    } else {
      firstBalance = balanceArray[day - 1] - principalArray[day - 1];

      firstInterest = (firstBalance * (interestRate / 100)) / numPaymentsPerYear;
      firstPrincipal = payment - firstInterest;
    }
    firstPrincipal = parseFloat(firstPrincipal.toFixed(2));
    balanceArray.push(firstBalance);
    interestArray.push(firstInterest);
    principalArray.push(firstPrincipal);
  }

  const firstYearInterestArray = interestArray.slice(0, 12);

  const mortgageInterest = firstYearInterestArray.reduce((aggr, val) => aggr + val, 0);

  return parseFloat(formatAmount(mortgageInterest));
}
